import { useState } from "react";
import { validateCoupon } from "../service/api";

function CouponInput({ onValid }) {

  const [code, setCode] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {

    e.preventDefault();

    if (!code) {
      setError("Please enter a code");
      return;
    }

    try {

      setLoading(true);
      const res = await validateCoupon(code);
      const payload = res.data.data;
      
      onValid({
        couponCode: code,
        quoteId: payload.quoteId,
        token: payload.token,
        products: payload.products || []
      });

    } catch (err) {
      setError("Invalid coupon");
    } finally {
      setLoading(false);
    }

  };

  return (
    <form className="coupon-form" onSubmit={handleSubmit}>

      <h2>Enter Your Jacket Code</h2>

      <input
        type="text"
        value={code}
        placeholder="Enter Code"
        onChange={(e) => setCode(e.target.value)}
      />

      <button type="submit" disabled={loading}>
        {loading ? "Checking..." : "Continue"}
      </button>

      {error && <p className="error">{error}</p>}

    </form>
  );
}

export default CouponInput;